import {
  Text,
  IconSignature,
  IconCircleX,
  GreyGrey70,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

import { NodeTimeline, QuotePreviewCard } from 'Automations/components'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useQuoteData } from '../../hooks/useQuoteData'

export const QuoteWebhookProcessingFailedPreview = (props: {
  taskId: string
}) => {
  const { manualTask } = useManualTask({ taskId: props.taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { quote, customer } = useQuoteData(input?.quoteId)

  const hasQuoteData = quote && customer

  return (
    <>
      <NodeTimeline.Item icon={<IconSignature />} showStem>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label="Quote created"
            timestamp={quote?.createdAt}
          />
        </NodeTimeline.Title>

        {hasQuoteData && (
          <QuotePreviewCard quote={quote} customer={customer} startCollapsed />
        )}
      </NodeTimeline.Item>

      <NodeTimeline.Item icon={<IconCircleX />} showStem={false} highlightIcon>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                Failed to process a Dropbox Sign webhook
              </Text>
            }
            timestamp={manualTask?.createdAt}
          />
        </NodeTimeline.Title>

        <Text {...Primary13Regular} color={GreyGrey70} marginBottom="16px">
          Our team is looking into it and will reach out to you with a
          resolution.
        </Text>

        {hasQuoteData && <QuotePreviewCard quote={quote} customer={customer} />}
      </NodeTimeline.Item>
    </>
  )
}
